import { useCallback, useContext, useMemo } from "react";
import { MainContext } from "../contexts";

export const useTimezone = (
  stationId?: string | number,
  plantId?: string | number,
  providedCompany?: any,
) => {
  const { company } = useContext(MainContext);

  const getTimezoneFn = (
    stationIdArg?: string | number,
    plantIdArg?: string | number,
    providedCompanyArg?: any,
  ) => {
    if (providedCompanyArg) {
      return providedCompanyArg.timezoneByStation?.[Number(stationIdArg)] ||
        providedCompanyArg.timezoneByPlant?.[Number(plantIdArg)] ||
        providedCompanyArg.timezone;
    }

    return company?.timezoneByStation?.[Number(stationIdArg)] ||
      company?.timezoneByPlant?.[Number(plantIdArg)] ||
      company?.timezone;
  };

  const timezone = useMemo(() => {
    return getTimezoneFn(stationId, plantId, providedCompany);
  }, [company, stationId, plantId, providedCompany]);

  const getTimezone = useCallback((
    stationIdArg?: number,
    plantIdArg?: number,
    providedCompanyArg?: any,
  ) => {
    return getTimezoneFn(stationIdArg, plantIdArg, providedCompanyArg);
  }, [company]);

  return { timezone, getTimezone };
};